import { NgIf } from '@angular/common';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { FormFieldControl } from './abstracts/form-field-control.abstract';
import { formFieldAnimations } from './animations/form-field.animations';

@UntilDestroy()
@Component({
  standalone: true,
  imports: [NgIf],
  selector: 'aw-form-field',
  templateUrl: 'form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  animations: [
    formFieldAnimations.transitionMessages,
    formFieldAnimations.controlErrorShake,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldComponent implements AfterContentInit {
  get showErrors(): boolean {
    return this.control?.hasError;
  }

  constructor(private readonly changeDetector: ChangeDetectorRef) {}

  @ContentChild(FormFieldControl, { static: true })
  private readonly control!: FormFieldControl<unknown>;

  ngAfterContentInit(): void {
    if (!this.control) {
      throw new Error(
        'A component that provides FormFieldControl must be used as part of a aw-form-field',
      );
    }

    this.initChangeDetectorHandlers(this.control);
  }

  private initChangeDetectorHandlers(control: FormFieldControl<unknown>): void {
    if (control.stateChanges) {
      control.stateChanges.pipe(untilDestroyed(this)).subscribe(() => {
        this.changeDetector.detectChanges();
      });
    }

    if (control.ngControl && control.ngControl.valueChanges) {
      control.ngControl.valueChanges
        .pipe(untilDestroyed(this))
        .subscribe(() => {
          this.changeDetector.markForCheck();
        });
    }
  }
}
